module.exports = __webpack_public_path__ + "img/hz_lc_img_ch.dbcf98c8.gif";